import styled from 'styled-components';
import { Button } from '@pearsontechnology/aero-components';

export const SearchClearButton = styled(Button)`
  margin: 0;
  padding: 0;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  justify-self: center;
  grid-column: 2;
  grid-row: 1;
  cursor: pointer;
`;

export const SearchContainer = styled.div`
  padding: 0 1px 16px;
  width: 200px;
  display: grid;
  grid-template-columns: 1fr 40px;

  > div {
    width: 100%;
    grid-column: 1 / span 2;
    grid-row: 1;
  }
`;
